import { IconAlertTriangle } from "@tabler/icons-react";

/**
 * PB-EDP-1 (plan synthetic-dancing-fog Rev. 4.2): the notice every
 * event-delete dialog shows when an event holds a paid event plan — the
 * Danger Zone, the archived row menu and the bulk delete. The copy comes from
 * `bulkConfirm.paidPlanWarning*` and is worded state-neutrally ("if it is
 * still running"), because `planType` stays paid after the plan expired.
 *
 * Static dialog content, so `role="note"` — never an alert: the Danger Zone's
 * e2e pins read the dialog's one `alert` (its error line).
 *
 * Colours are PBanner's `warning` tone (amber surface + border, primary text,
 * dark-amber icon — contrast checked there for light and dark). Not
 * `surface-warning-light` / `font-warning`: neither utility is defined, so
 * they render nothing.
 */
export const EventDeletePaidPlanNotice: React.FC<{ text: string }> = ({ text }) => (
  <div
    role="note"
    data-testid="event-delete-paid-plan-warning"
    className="w-full flex items-start gap-2 px-3 py-2.5 rounded-xl border surface-status-amber-bg outline-status-amber body-3-regular font-primary"
  >
    <IconAlertTriangle size={16} className="shrink-0 mt-0.5 font-status-amber-dark" aria-hidden="true" />
    <span>{text}</span>
  </div>
);
